import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

import { environment } from '../../../environments/environment';

interface Pillar {
  icon: string;
  titleKey: string;
  bodyKey: string;
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, MatCardModule, MatButtonModule, MatIconModule, TranslocoModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent {
  // Returning operators go to the admin-ui sign-in (a separate app), so this is
  // an external href, not a routerLink. Bare /signin — no client_id handoff
  // (that's only appended on the post-signup path).
  protected readonly adminSigninUrl = environment.adminSigninBaseUrl;

  // Hold Transloco keys (not display text) so a live language switch re-renders
  // via the `transloco` pipe in the template. Story 25.6.
  protected readonly trustChips: string[] = [
    'common.trustChips.euHosted',
    'common.trustChips.openSource',
    'common.trustChips.specCorrect',
    'common.trustChips.wcag',
  ];

  protected readonly pillars: Pillar[] = [
    {
      icon: 'lock',
      titleKey: 'home.pillars.tenantIsolation.title',
      bodyKey: 'home.pillars.tenantIsolation.body',
    },
    {
      icon: 'code',
      titleKey: 'home.pillars.sealedAdmin.title',
      bodyKey: 'home.pillars.sealedAdmin.body',
    },
    {
      icon: 'sync',
      titleKey: 'home.pillars.productionAsLabel.title',
      bodyKey: 'home.pillars.productionAsLabel.body',
    },
    {
      icon: 'mail',
      titleKey: 'home.pillars.inviteFlow.title',
      bodyKey: 'home.pillars.inviteFlow.body',
    },
  ];
}
